import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import dataGammes from './gammes.js';

/**
 * Gamme block molecule. Used in Odil interfaces.
 * @prop Gamme The gamme variable. Is the gamme name.
 * @prop type The type of bloc primary|other.
 *
 */
@customElement('nn-gammes-block')
export class GammesBlock extends LitElement {
  static styles = css`
    .figure {
      align-items: flex-start;
      display: flex;
      gap: 16px;
      grid-template-columns: inherit;
      justify-content: flex-start;
      flex-wrap: wrap;
    }

    .figure nn-card-gamme {
      max-width: 100%;
      width: 100%;
    }
  `;

  @property({ type: String }) gamme = '';

  @property({ type: String }) type = 'primary';

  @property({ type: String }) context = 'odil';

  render() {
    const itemTemplates: any = [];
    dataGammes.forEach((element: any) => {
      if (element.gamme === this.gamme) {
        element.children.forEach((child: any) => {
          itemTemplates.push(html` <nn-card-gamme
            imageSrc="${child.imageSrc}"
            .title="${child.title}"
            .subTitle="${child.subTitle}"
          >
          </nn-card-gamme>`);
        });
      }
    });
    return html` <div class="figure">${itemTemplates}</div>`;
  }
}
